import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { Text } from 'bench-internal-theme';

export const Transaction1099ViewContentArea = styled.div`
  left: 0;
  overflow: auto;
  padding: 32px;
  height: 100%;
`;

export const BulkEditFormArea = styled.div`
  background: ${colors.pearl};
  box-shadow: 0 -1px ${colors.silt};
  overflow: auto;
  position: sticky;
  bottom: 0;
  z-index: 1;
`;

export const DataEntriesCount = styled(Text).attrs(() => ({
  color: colors.smoke,
  styleType: 'mediumBold',
}))`
  margin-left: 8px;
`;

export const TableHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 32px;
`;
